module.exports = __webpack_public_path__ + "img/image00002.13cf7d42.jpg";